import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "components";
import {
	DocumentsServiceContext,
	DocumentsTable,
} from "components/documentsTable";
import { documentsService } from "services";
import { uiActions } from "store";
import { useSubmitPreApplicationMutation } from "queries";

import clsx from "clsx";
import styles from "../stepper.module.scss";

const DocumentsStep = ({ prevStep, nextStep, token }) => {
	const dispatch = useDispatch();
	const applicationId = useSelector(state => state.generalInfo.applicationId);

	const handleAddDocument = ({ addDocument }) => {
		dispatch(
			uiActions.showModal("DocumentModal", {
				onAddDocument(document) {
					return addDocument({ entityId: applicationId, document });
				},
			}),
		);
	};

	const handleDeleteDocument = ({ document, deleteDocument }) => {
		dispatch(
			uiActions.showModal("ConfirmationModal", {
				title: "Are you sure you want to delete the document?",
				onConfirm() {
					return deleteDocument({
						entityId: applicationId,
						documentId: document.id,
					});
				},
			}),
		);
	};

	const handleViewDocument = ({ document, viewDocument }) => {
		return viewDocument({
			entityId: applicationId,
			documentId: document.id,
		});
	};

	const handleDownLoadDocument = ({ document, downloadDocument }) => {
		return downloadDocument({
			entityId: applicationId,
			documentId: document.id,
		});
	};

	const {
		mutateAsync: submitPreApplication,
	} = useSubmitPreApplicationMutation({ token, nextStep, applicationId });

	return (
		<div className={styles.form}>
			<h1 className={styles.header}>
				Please upload a copy of a voided check, if possible
			</h1>
			<span style={{ fontSize: 12 }} className="mb-3">
				If you don't upload a copy of a voided check now, it will be
				required later for account approval
			</span>
			<DocumentsServiceContext.Provider
				value={{
					key: "applicationDocuments",
					service: documentsService,
				}}
			>
				<DocumentsTable
					entityId={applicationId}
					AddDocumentButton={({ addDocument }) => {
						return (
							<Button
								onClick={() => {
									handleAddDocument({ addDocument });
								}}
								value="Add Document"
							/>
						);
					}}
					onViewDocument={handleViewDocument}
					onDownloadDocument={handleDownLoadDocument}
					onDeleteDocument={handleDeleteDocument}
				/>
			</DocumentsServiceContext.Provider>
			<div className={clsx("d-flex", "flex-row-reverse", "mt-3")}>
				<Button
					type="button"
					onClick={submitPreApplication}
					isPrimary={true}
				>
					submit
				</Button>
				<Button type="button" onClick={prevStep} className="mr-4">
					previous step
				</Button>
			</div>
		</div>
	);
};

export { DocumentsStep };
